import { render } from "./HmdaWithdrawalDashboard.vue?vue&type=template&id=789a57be&scoped=true"
import script from "./HmdaWithdrawalDashboard.vue?vue&type=script&lang=js"
export * from "./HmdaWithdrawalDashboard.vue?vue&type=script&lang=js"

import "./HmdaWithdrawalDashboard.vue?vue&type=style&index=0&id=789a57be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789a57be"]])

export default __exports__